// Frontend-only UI grouping for canonical category slugs.
// The backend doesn't care about groupings — it validates against
// the flat CATEGORY_OPTIONS list. This file exists so the prospect
// research picker can render categories in labeled sections.

import type { Category } from './categories';

export interface CategoryGroup {
  id: string;
  label: string;
  slugs: ReadonlyArray<Category>;
}

export const CATEGORY_GROUPS: ReadonlyArray<CategoryGroup> = [
  {
    id: 'automotive',
    label: 'Automotive',
    slugs: [
      'auto_repair',
      'auto_body',
      'auto_parts',
      'transmission',
      'oil_change',
      'tire_service',
      'towing',
    ],
  },
  {
    id: 'trades',
    label: 'Home Trades & Construction',
    slugs: [
      'plumbing',
      'electrical',
      'hvac',
      'electronics',
      'roofing',
      'gutters',
      'siding',
      'awnings',
      'painting',
      'flooring',
      'remodeling',
      'concrete',
      'patios',
      'fencing',
      'pressure_washing',
      'appliance_repair',
      'general_contractor',
      'windows_doors',
      'fence_deck',
      'handyman',
    ],
  },
  {
    id: 'outdoor',
    label: 'Outdoor & Property',
    slugs: [
      'landscaping',
      'lawn_care',
      'tree_service',
      'pool_service',
    ],
  },
  {
    id: 'cleaning',
    label: 'Cleaning & Removal',
    slugs: [
      'house_cleaning',
      'carpet_cleaning',
      'pest_control',
      'junk_removal',
      'mold_remediation',
      'water_damage_restoration',
    ],
  },
  {
    id: 'pet',
    label: 'Pet Services',
    slugs: [
      'dog_training',
      'pet_grooming',
      'pet_sitting',
      'pet_boarding',
      'veterinary',
    ],
  },
  {
    id: 'professional',
    label: 'Professional & Personal Services',
    slugs: [
      'legal',
      'accounting',
      'insurance',
      'real_estate',
      'moving',
      'catering',
      'photography',
      'tutoring',
    ],
  },
];
